import { create } from 'zustand';
import { PropsGetRecomendacaoPrint, getPrintRequiredData } from './utils';
import {
  RecomendacaoSemeadura,
  RecomendacaoSemeaduraSituacao,
  Safra,
} from '../../@types';

type PrintRecomendacaoState = {
  dataToPrint: PropsGetRecomendacaoPrint;
};

type PrintRecomendacaoActions = {
  fetchDataToPrint: (
    baseObject: RecomendacaoSemeadura,
    safras: Safra[],
  ) => Promise<void>;
  clear: () => void;
};

const initialState = {
  dataToPrint: {
    situacao: 'aberto' as RecomendacaoSemeaduraSituacao,
    status: 'rascunho',
    adubos: [],
    sementeCobertura: false,
    comMargemSeguranca: false,
    talhoes: [],
  },
};

const usePrintRecomendacaoStore = create<
  PrintRecomendacaoState & PrintRecomendacaoActions
>((set) => ({
  ...initialState,

  clear: () => set(initialState),

  fetchDataToPrint: async (
    baseObject: RecomendacaoSemeadura,
    safras: Safra[],
  ) => {
    const newPrintData = await getPrintRequiredData(baseObject, safras);
    set({ dataToPrint: newPrintData });
  },
}));

export default usePrintRecomendacaoStore;
